<form [formGroup]="registerForm" novalidate>
  <tc-form-group>
    <!--    <tc-form-label>{{'HOME.label.name'| translate}} *</tc-form-label>-->
    <tc-input formControlName="full_name" required
              [placeholder]="'HOME.label.name'| translate"></tc-input>
  </tc-form-group>

  <tc-form-group>
    <!--    <tc-form-label>{{'HOME.label.pseudo'| translate}} *</tc-form-label>-->
    <tc-input formControlName="pseudo" required
              [placeholder]="'HOME.label.pseudo'| translate"></tc-input>
  </tc-form-group>


  <tc-form-group>
    <!--    <tc-form-label>{{'HOME.label.mail'| translate}} *</tc-form-label>-->
    <tc-input formControlName="email" required email
              [placeholder]="'HOME.label.mail'| translate"></tc-input>
  </tc-form-group>

  <tc-form-group style="position: relative">
    <!--    <tc-form-label>{{'HOME.label.password'| translate}} *</tc-form-label>-->
    <tc-input formControlName="password" [type]="showNewPass?'text': 'password'"
              required [placeholder]="'HOME.label.password'| translate"></tc-input>
    <tc-icon [iconClass]="showNewPass? 'icofont-eye-alt':'icofont-eye-blocked'"
             [tcColor]="'#8f8f90'" class="password_prefix" (click)="showNewPass=!showNewPass"></tc-icon>
  </tc-form-group>

  <tc-form-group style="position: relative">
    <!--    <tc-form-label>{{'HOME.label.confirm_password'| translate}} *</tc-form-label>-->
    <tc-input formControlName="confirmPassword" [type]="showConfPass?'text': 'password'"
              required [placeholder]="'HOME.label.confirm_password'| translate"></tc-input>
    <tc-icon [iconClass]="showConfPass? 'icofont-eye-alt':'icofont-eye-blocked'"
             [tcColor]="'#8f8f90'" class="password_prefix" (click)="showConfPass=!showConfPass"></tc-icon>
  </tc-form-group>

  <div style="margin: 0 0 10px 0;">
    <re-captcha (resolved)="resolvedCaptcha($event)" [siteKey]="captcha_key"></re-captcha>
  </div>

  <div class="actions justify-content-between">
    <button mat-button mat-raised-button [color]="'primary'"
            [disabled]="registerForm.invalid" type="submit"
            (click)="submiData()">
      Register
    </button>
  </div>
</form>
